import { TFunction } from 'i18next';
import { ASSISTANT_INTENT } from 'src/contexts/assistant/constants';
import {
    ACTION_TYPE,
    DEFAULT_APPOINTMENT_DURATION_MINUTES,
} from 'src/modules/assistant/constants/actions';
import {
    TActionDraft,
    TRecommendation,
} from 'src/modules/assistant/types/message';
import { getRecommendationScheduledAt } from './getRecommendationScheduledAt';

const REPLY_INTENTS: string[] = [
    ASSISTANT_INTENT.WHATSAPP,
    ASSISTANT_INTENT.CONVERSATION,
    ASSISTANT_INTENT.VIEW_APPOINTMENT,
];

/**
 * Builds the editable action draft for the option the user picked on a recommendation.
 * Returns null when the intent has no draft.
 */
export const buildRecommendationDraft = (
    intent: string,
    recommendation: TRecommendation,
    leadEmail: string | undefined,
    t: TFunction
): TActionDraft | null => {
    const suggestedText = [recommendation.title, recommendation.reason]
        .filter(Boolean)
        .join('. ');

    if (intent === ASSISTANT_INTENT.WHATSAPP && recommendation.templateId)
        return {
            type: ACTION_TYPE.SEND_TEMPLATE,
            summary: recommendation.title,
            templateId: recommendation.templateId,
            templateTitle: recommendation.templateTitle,
        };
    if (REPLY_INTENTS.includes(intent))
        return {
            type: ACTION_TYPE.REPLY_WHATSAPP,
            summary: recommendation.title,
            message:
                recommendation.customerMessage ||
                t('Assistant.CustomerMessageFallback'),
        };
    if (intent === ASSISTANT_INTENT.APPOINTMENT)
        return {
            type: ACTION_TYPE.CREATE_APPOINTMENT,
            summary: recommendation.title,
            title: recommendation.title || t('Assistant.AppointmentDraft'),
            description: suggestedText,
            email: leadEmail || '',
            scheduledAt: getRecommendationScheduledAt(recommendation),
            durationMinutes: DEFAULT_APPOINTMENT_DURATION_MINUTES,
        };
    if (intent === ASSISTANT_INTENT.TASK)
        return {
            type: ACTION_TYPE.CREATE_TASK,
            summary: recommendation.title,
            description: suggestedText,
            scheduledAt: getRecommendationScheduledAt(recommendation),
        };
    return null;
};
